// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// RxJS
import { Observable, Subject } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';
// Translate
import { TranslateService } from '@ngx-translate/core';
// Store
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
// Auth
import { AuthNoticeService, AuthService, Login, User, UserLoaded } from '../../../../core/auth';

import { AppService } from '../../../../services/app.service';

import { environment } from '../../../../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { StateService } from '../../../../services/state.service';

import { Stringable, StringableValues } from '../../../../common/stringable.decorator'

import { MatSnackBar } from '@angular/material';

import { MenuConfig } from '../../../../core/_config/demo1/menu.config';

/**
 * ! Just example => Should be removed in development
 */
const DEMO_PARAMS = {
	EMAIL: 'utilisateur@exemple.com',
	PASSWORD: ''
};

const KEY = 'login-component'

@Component({
	selector: 'kt-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	encapsulation: ViewEncapsulation.None
})

@Stringable({
	path: 'views/pages/auth/login',
	key: KEY,
})

export class LoginComponent implements OnInit, OnDestroy {
	// Public params
	@StringableValues(KEY) strings: any
	
	loginForm: FormGroup;
	loading = false;
	isLoggedIn$: Observable<boolean>;
	errors: any = [];

	private unsubscribe: Subject<any>;

	private returnUrl: any;
    
    private openid:boolean=false;
    
    private messages:any={
		SANITAIRE: {
			message:null,
			link:null
		},
		MENTIONS_LEGALES: {
			message:null,
			link:null
		},
		COOKIES: {
			message:null,
			link:null
		},
		RGPD: {
			message:null,
			link:null
		},
		OPENID: {
			message:null,
			link:null
		}
		
	}
    
    message_app: string;
	message_app_color: string;
    
	// Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param router: Router
	 * @param auth: AuthService
	 * @param authNoticeService: AuthNoticeService
	 * @param translate: TranslateService
	 * @param store: Store<AppState>
	 * @param fb: FormBuilder
	 * @param cdr
	 * @param route
	 */
	constructor(
		private router: Router,
		private auth: AuthService,
		private authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private store: Store<AppState>,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute,
		private appService: AppService,
		private stateService: StateService		,
		private snackBar: MatSnackBar
	) {
		this.unsubscribe = new Subject();
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		// redirect back to the returnUrl before login
		this.route.queryParams.subscribe(params => {
			this.returnUrl = params['returnUrl'] || '/';
			if (this.returnUrl!="/")
				localStorage.setItem('AtylreturnUrl', this.returnUrl)
			console.log("login message AtylreturnUrl",localStorage.getItem('AtylreturnUrl'));	
		});
		this.initLoginForm();

		
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.authNoticeService.setNotice(null);
		//this.unsubscribe.next();
		//this.unsubscribe.complete();
		this.loading = false;
	}

	_setMenuDashBord(menus:any) {
		
		console.log("LoginComponent _setMenuDashBord",menus)
		if (Array.isArray(menus)&&  menus.length>0) {
			//this.stateService.updateMenuItems(menus);
			let mns:any[]=[]
			for(let i=0;i<menus.length;i++) {
		    	  let mn:any=menus[i];
				  if (mn.submenu!=undefined && Array.isArray(mn.submenu) &&  mn.submenu.length>0 ) {
					for(let j=0;j<mn.submenu.length;j++) 
						mns.push(mn.submenu[j]);
					}else {
						mns.push(mn);
					}
					
		      /* if (mn.page!=undefined &&  mn.page=="dashboard")
				  this.stateService.updateMenuItem(mn);*/
			} 
			this.stateService.updateMenuItems(mns);
		}
	}
	
	/**
	 * Form initalization
	 * Default params, validators
	 */
	initLoginForm() {
		let _opt:any={
			
		};
		this.appService.accueil(_opt).subscribe((result:any) => {
			console.log("login message before",this.messages,result);
			if (result.result!=undefined) {
				this.messages=result.result;
				console.log("login message after",this.messages,result.result);
				this.stateService.updateMessages(this.messages);
			
				if (this.messages.APP_MENTION!=undefined 
				&& this.messages.APP_MENTION.message!=undefined) {
					this.message_app=this.messages.APP_MENTION.message;
				}

				if (this.messages.APP_MENTION_COLOR!=undefined 
					&& this.messages.APP_MENTION_COLOR.message!=undefined) {
						this.message_app_color=this.messages.APP_MENTION_COLOR.message;
				}		
				
				this.cdr.detectChanges();
			}
			
	   });
		
		// demo message to show
		if (!this.authNoticeService.onNoticeChanged$.getValue()) {
			/*const initialNotice = `Saisissez votre email
			<strong>${DEMO_PARAMS.EMAIL}</strong> et votre mot de passe
			<strong>${DEMO_PARAMS.PASSWORD}</strong> pour continuer.`;*/
			const initialNotice = 
				"Saisissez votre nom d'utilisateur ou votre adresse de messagerie" 
				+ " et votre mot de passe pour vous connecter."
			this.authNoticeService.setNotice(initialNotice, 'info');
		}

		this.loginForm = this.fb.group({
			email: ['', Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(320) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])
			],
			password: [DEMO_PARAMS.PASSWORD, Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(100)
			])
			]
		});
		this.loading = true;
		this.appService.getConnectToken().subscribe((token) => {
			environment.tokencsrf = token.result.token;
			this.loading = false;
			this.openid=false;
			this.cdr.detectChanges();
			/*this.appService.send401().subscribe(
			(res401) => {
				console.log(res401);
			},
			error => {
				if(error.status === 401){
			*/
				this.auth
				.kindOpenId()
				.pipe(
					tap(connect => {
						if (connect=="none" || connect=="login")
						   this.openid=true;
					}),
					takeUntil(this.unsubscribe),
					finalize(() => {
						
						this.cdr.detectChanges();
					})
				).subscribe(() => {
				});
					
			
				
					this.auth
				.loginLDAP()
				.pipe(
					tap(user => {
						if(user instanceof User)
						{
							this.store.dispatch(new Login({authToken: user.accessToken}));
                            
							this.appService.getTiersTypeList().subscribe(res => {
							       if (res.result!=undefined)
							             this.stateService.updateTypeTiers(res.result);
							});
							
							
                            this.appService.application().subscribe(res => {
                                if (res.result!=undefined)
                                    this.stateService.updateApplication(res.result);
                            });
							
							this.appService.getMenuList().subscribe(res => {
	                              if (res.result!=undefined) {
										const mn = new MenuConfig(this.appService);
										
										mn.setItems(res.result);
										this.stateService.updateMenu(mn.configs);
	                                    this._setMenuDashBord(res.result);
									  
									}  
							});
							
							this.appService.getTypeCommunication().subscribe(res => {
					            if (res.result!=undefined) {
														
									this.stateService.updateCommunication(res.result);
													  
								}  
							});
							
							localStorage.removeItem("ConnectOpenID");
                            const r:any=localStorage.getItem('AtylreturnUrl')
                            console.log("connect ldap",r);
							/*if(r != "/")
								this.router.navigateByUrl(r); // Main page
							else*/
								this.router.navigate(["/home"],{queryParams: {redirect: r}}); // Main page
						}else {
							console.log("loginLDAP",user)
							if (user.openid !=undefined && user.openid
							&& user.openid_connect !=undefined 
							&& user.openid_connect=="login"
							 ) {
								 this.openid=true;
								 
							 }
							 let item:any =localStorage.getItem("ConnectOpenID");
						 if(item && user.userFound!=undefined && ! user.userFound){
						 									let messageCnx:string='Connexion fonctionnelle impossible:';
						 									messageCnx+='\nVotre utlisateur est inconnu d\'Atyl';
						 									messageCnx+='\nVeuillez contacter votre administrateur';
						 										this.snackBar.open(messageCnx,'', {
						 									           duration: 5000,
						 											   panelClass: ['success-snackbar']
						 									 });		
						 } 
						 
						 localStorage.removeItem("ConnectOpenID");
						 
							
						}
					}),
					takeUntil(this.unsubscribe),
					finalize(() => {
						this.loading = false;
						this.cdr.detectChanges();
					})
				).subscribe(() => {
				});
			/*		
				}
			}
			);*/
		});
		
		/*
		this.appService.send401().subscribe(
			(res401) => {
				console.log(res401);
			},
			error => {
				if(error.status === 401){
					
					this.appService.connectLdap().subscribe((res) => {
						
						if(!res.error && res.result && res.result.connect === 'OK'){
							console.log("ldap token",res.result.token);
							this.store.dispatch(new Login({authToken: res.result.token}));
							this.loading = false;
							this.cdr.detectChanges();
							this.router.navigateByUrl("/home"); 
						}
						this.loading = false;
						this.cdr.detectChanges();
					});
				}
			}
		);*/
	}

	/**
	 * Form Submit
	 */
	submit() {
		
		const controls = this.loginForm.controls;
		/** check form */
		if (this.loginForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		this.loading = true;

		const authData = {
			email: controls['email'].value,
			password: controls['password'].value
		};

		
		this.appService.getConnectToken().subscribe((token) => {
			environment.tokencsrf = token.result.token;
			this.loading = false;
			this.cdr.detectChanges();
			this.auth
				.login(authData.email, authData.password)
				.pipe(
					tap(user => {
						if(user)
						{
							this.store.dispatch(new Login({authToken: user.accessToken}));
                            
							this.appService.getTiersTypeList().subscribe(res => {
														       if (res.result!=undefined)
														             this.stateService.updateTypeTiers(res.result);
							});
							
                             this.appService.application().subscribe(res => {
                                if (res.result!=undefined)
                                    this.stateService.updateApplication(res.result);
                            });
							this.appService.getMenuList().subscribe(res => {
                              if (res.result!=undefined) {
									const mn = new MenuConfig(this.appService);
									
									mn.setItems(res.result);
									this.stateService.updateMenu(mn.configs);
									this._setMenuDashBord(res.result);
								  
								}  
						});
							
						this.appService.getTypeCommunication().subscribe(res => {
                              if (res.result!=undefined) {
									
								this.stateService.updateCommunication(res.result);
														  
								}  
						});
						
						
							localStorage.removeItem('ConnectOpenID');
                             const r:any=localStorage.getItem('AtylreturnUrl');
							console.log("connect login",r);
							/*if(r != "/") {
								this.router.navigateByUrl(r); // Main page
								
							}	
							else*/
							//	this.router.navigateByUrl("/home"); // Main page
								this.router.navigate(["/home"],{queryParams: {redirect: r}}); 	
						}else {
							this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_LOGIN'), 'danger');
							
							Object.keys(controls).forEach(controlName =>
								controls[controlName].setValue("")
							);
						}
					}),
					takeUntil(this.unsubscribe),
					finalize(() => {
						this.loading = false;
						this.cdr.detectChanges();
					})
				).subscribe(() => {
				});
		});
	}

	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.loginForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}
	
	connectOpenId() {
			this.auth
				.loginOpenId()
				.pipe(
					tap(user => {
						if(user instanceof User)
						{
							this.store.dispatch(new Login({authToken: user.accessToken}));
                            
							this.appService.getTiersTypeList().subscribe(res => {
														       if (res.result!=undefined)
														             this.stateService.updateTypeTiers(res.result);
							});
							
                            this.appService.application().subscribe(res => {
                                if (res.result!=undefined)
                                    this.stateService.updateApplication(res.result);
                            });
							
							this.appService.getMenuList().subscribe(res => {
	                              if (res.result!=undefined) {
										const mn = new MenuConfig(this.appService);
										
										mn.setItems(res.result);
										this.stateService.updateMenu(mn.configs);
										this._setMenuDashBord(res.result);
									  
									}  
							});
							
							this.appService.getTypeCommunication().subscribe(res => {
	                              if (res.result!=undefined) {
										
									this.stateService.updateCommunication(res.result);
									}												  
							});
							
                               const r:any=localStorage.getItem('AtylreturnUrl');
							   localStorage.removeItem('ConnectOpenID');
							/*if(this.returnUrl != "/")
								this.router.navigateByUrl(this.returnUrl); // Main page
							else*/
							//	this.router.navigateByUrl("/home"); // Main page
								this.router.navigate(["/home"],{queryParams: {redirect: r}}); 
						}else {
							//this.openid=false;
							console.log("loginOpenId",user);
							let item:any =localStorage.getItem("ConnectOpenID");
							
							if(item && user.userFound!=undefined && ! user.userFound){
									let messageCnx:string='Connexion fonctionnelle impossible:';
									messageCnx+='\nVotre utlisateur est inconnu d\'Atyl';
									messageCnx+='\nVeuillez contacter votre administrateur';
										this.snackBar.open(messageCnx,'', {
									           duration: 3000,
											   panelClass: ['success-snackbar']
									 });		
							} 
							
								localStorage.removeItem ('ConnectOpenID');
							
							 if (user!=undefined && user.auth_point!=undefined && user.auth_point ) {
								localStorage.setItem('ConnectOpenID', "TRUE");
								window.location.href=user.auth_point;
							}
							
						}
					}),
					takeUntil(this.unsubscribe),
					finalize(() => {
						this.loading = false;
						this.cdr.detectChanges();
					})
				).subscribe(() => {
				});
	}
}
